import { NavLink } from "@remix-run/react";
import { NavIconProps } from "~/utils/interfaces/components";

const ServicesIcon = (props: NavIconProps) => {
  const {
    width = 24,
    height = 24,
    color = "#BCBCBC",
    color2 = "#3fff6f",
    label = "",
    selected = false,
    name = "home",
  } = props;

  return (
    <NavLink
      to={name}
      aria-label="Services"
      className={({ isActive, isPending }) => {
        return `nav-item-container ${
          isActive ? "active" : isPending ? "pending" : ""
        }`;
      }}
    >
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${24} ${24}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.1298 15.8799C10.8798 15.8799 10.6298 15.7499 10.4898 15.5199C10.2798 15.1699 10.3898 14.6999 10.7498 14.4899L11.6398 13.9599V12.8799C11.6398 12.4699 11.9798 12.1299 12.3898 12.1299C12.7998 12.1299 13.1398 12.4699 13.1398 12.8799V14.3799C13.1398 14.6399 12.9998 14.8899 12.7798 15.0199L11.5298 15.7699C11.3898 15.8399 11.2598 15.8799 11.1298 15.8799Z"
          fill={color}
          className="svg-path"
        />
        <path
          opacity="0.4"
          d="M21.8499 11.4102L21.2299 18.1902C21.0199 20.1902 20.1999 22.2302 15.7999 22.2302H8.1799C3.7799 22.2302 2.9599 20.1902 2.7599 18.2002L2.1499 11.6902C2.1599 11.7002 2.1699 11.7102 2.1899 11.7202C2.5299 11.9402 2.8599 12.1602 3.2199 12.3602C3.3599 12.4502 3.5099 12.5302 3.6599 12.6102C4.7899 13.2302 5.9999 13.7202 7.2499 14.0602C7.7499 14.2102 8.2599 14.3202 8.7799 14.4102C8.9799 16.0102 10.3499 17.2502 11.9999 17.2502C13.6699 17.2502 15.0499 15.9802 15.2299 14.3502V14.3402C15.7399 14.2402 16.2499 14.1102 16.7499 13.9602C17.9999 13.5702 19.2099 13.0502 20.3399 12.3902C20.3999 12.3602 20.4499 12.3302 20.4899 12.3002C20.9499 12.0502 21.3899 11.7602 21.8099 11.4602C21.8299 11.4502 21.8399 11.4302 21.8499 11.4102Z"
          fill={color}
          className="svg-path"
        />
        <path
          d="M21.09 6.98002C20.24 6.04002 18.83 5.57002 16.76 5.57002H16.52V5.53002C16.52 3.85002 16.52 1.77002 12.76 1.77002H11.24C7.48004 1.77002 7.48004 3.85002 7.48004 5.53002V5.57002H7.24004C5.17004 5.57002 3.75004 6.04002 2.91004 6.98002C1.92004 8.09002 1.95004 9.56002 2.05004 10.57L2.06004 10.64L2.15004 11.69C2.16004 11.7 2.18004 11.71 2.20004 11.72C2.54004 11.94 2.87004 12.16 3.23004 12.36C3.37004 12.45 3.52004 12.53 3.67004 12.61C4.80004 13.23 6.01004 13.72 7.25004 14.06C7.28004 16.65 9.40004 18.75 12 18.75C14.62 18.75 16.75 16.62 16.75 14V13.96C18.01 13.58 19.22 13.05 20.35 12.39C20.41 12.36 20.45 12.33 20.5 12.3C20.96 12.05 21.4 11.76 21.82 11.46C21.83 11.45 21.85 11.43 21.86 11.41L21.9 11.05L21.95 10.58C21.96 10.52 21.96 10.47 21.97 10.4C22.05 9.40002 22.03 8.02002 21.09 6.98002ZM8.91004 5.53002C8.91004 3.83002 8.91004 3.19002 11.24 3.19002H12.76C15.09 3.19002 15.09 3.83002 15.09 5.53002V5.57002H8.91004V5.53002ZM12 17.25C10.35 17.25 8.98004 16.01 8.78004 14.41C8.76004 14.28 8.75004 14.14 8.75004 14C8.75004 12.21 10.21 10.75 12 10.75C13.79 10.75 15.25 12.21 15.25 14C15.25 14.12 15.24 14.23 15.23 14.34V14.35C15.05 15.98 13.67 17.25 12 17.25Z"
          fill={color}
          className="svg-path"
        />
      </svg>
      <p className="nav-label">{label}</p>
    </NavLink>
  );
};

export default ServicesIcon;
